/* render-svg.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./render-svg.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Image from '@atlaskit/image';
var imageSizeStyles = {
  xlarge: "_1bsb1lit",
  large: "_1bsb53f4",
  medium: "_1bsb1wqb"
};
export var RenderSVG = function RenderSVG(_ref) {
  var alt = _ref.alt,
    size = _ref.size,
    src = _ref.src,
    srcDark = _ref.srcDark;
  return /*#__PURE__*/React.createElement(Image, {
    src: src,
    srcDark: srcDark,
    alt: alt,
    className: ax([size && imageSizeStyles[size]])
  });
};